/**
 * Vertical layout for fixed bottom-right FABs.
 * Ask Teta stays at the corner; public-info FABs stack above when Teta is enabled.
 */
export const PUBLIC_INFO_FAB_SIZE_PX = 40;
export const PUBLIC_INFO_FAB_STACK_GAP_PX = 6;

/** MUI default Fab diameter. */
export const TETA_FAB_SIZE_PX = 56;
export const TETA_FAB_BOTTOM_PX = 24;
export const GAP_ABOVE_TETA_FAB_PX = 16;

export const FLOATING_ACTIONS_RIGHT = {
  xs: 12,
  sm: 20,
  lg: 24
} as const;

export const TETA_FAB_COLOR = "#FFC107";
export const TETA_FAB_COLOR_HOVER = "#FFB300";
export const TETA_FAB_ICON_COLOR = "#1a1a1a";

const tetaReservedHeightPx = TETA_FAB_SIZE_PX + GAP_ABOVE_TETA_FAB_PX;

/** Public FAQ / Contact stack — above Ask Teta when assistant is on. */
export const PUBLIC_INFO_FLOATING_BOTTOM_ABOVE_TETA = {
  xs: `calc(16px + ${tetaReservedHeightPx}px + env(safe-area-inset-bottom, 0px))`,
  sm: `calc(20px + ${tetaReservedHeightPx}px + env(safe-area-inset-bottom, 0px))`,
  lg: TETA_FAB_BOTTOM_PX + tetaReservedHeightPx
} as const;

/** Default position when Ask Teta is disabled. */
export const PUBLIC_INFO_FLOATING_BOTTOM_DEFAULT = {
  xs: "calc(16px + env(safe-area-inset-bottom, 0px))",
  sm: "calc(20px + env(safe-area-inset-bottom, 0px))",
  lg: TETA_FAB_BOTTOM_PX
} as const;
